export default "__VITE_ASSET__n$LXm_Ut__"